<template>
  <div id="app">
    <div class="configurator">
      <div
        class="mobile-progress d-lg-none bg-light"
        :class="{remove:state.resume}"
        @click="displayEndResume"
      >
        <span
          class="bg-primary text-center text-white"
          :style="'width: '+(stepNumber/10)*100+'%;'"
        > <small><strong>{{ stepNumber }}</strong>/10</small></span>
      </div>
      <top-nav />
      <div class="content-wrapper">
        <a
          v-if="$route.name!=='FirstChoice'"
          class="mb-0 return"
          @click="$router.go(-1)"
        >
          <i class="fal fa-arrow-left" />
          <span>retour</span>
        </a>
        <router-view />
      </div>
    </div>
    <side-resume />
  </div>
</template>

<script>
const TopNav = () => import('@/components/TopNav.vue')
const SideResume = () => import('@/components/SideResume.vue')

export default {
  components: {
    TopNav,
    SideResume
  },
  computed: {
    state() {
      return this.$store.state;
    },
    stepNumber() {
      switch (this.$route.name) {
        case 'FirstChoice':
          return 1;
        case 'HouseType':
          return 2;
        case 'RegionSelection':
          return 3;
        case 'RoomType':
          return 4;
        case 'SurfaceSelection':
          return 5;
        case 'PowerShow':
          return 6;
        case 'PowerSelection':
          return 6;
        case 'OrientationSelection':
          return 7;
        case 'ColorSelection':
          return 7;
        case 'FinitionSelection':
          return 7;
        case 'ThermostatSelection':
          return 8;
        case 'TowelSelection':
          return 8;
        case 'PilotingSelection':
          return 9;
        default:
          return null
      }
    }
  },
  watch: {
    '$route.name': {
      handler() {
        this.setData('resumeLast', false)
        this.setData('resume', false)
      }
    }
  },
  created() {
    if (!this.state.known_power && this.$route.name !== 'FirstChoice') this.$router.push({name: 'FirstChoice'})
  },
  methods: {
    displayEndResume() {
      if ((this.$route.name !== 'FirstChoice' && this.$route.name !== 'HouseType' && this.$route.name !== 'RegionSelection' && !this.state.known_power)
          || (this.state.known_power && this.$route.name !== 'RoomType' && this.$route.name !== 'FirstChoice')) this.setData('resume', true)
    }
  }
}

window.addEventListener('scroll', function(e) {
  document.getElementById("test").style.opacity = "1";
  setTimeout(function(){
    document.getElementById("test").style.opacity = "0";
  }, 200);
});
</script>
